import React from 'react';
import {
    Div,
    FormItem,
    Input,
    SplitLayout,
    SplitCol,
    Button, ModalPage, ModalPageHeader, PanelHeaderButton, Group, ButtonGroup, ModalRoot
} from '@vkontakte/vkui';
import axios from "axios";
import * as constants from "../assets/constants";
import {Icon12CheckCircle, Icon16ArrowshapeRightOutline, Icon24Cancel} from "@vkontakte/icons";
import CartApi from "../api/CartApi";
import checkMods from "./checkMods";
import BaseComponent from "../components/BaseComponent";
import {getProductOrderBlock, getScladBlockReason, keyBase} from "../assets/constants";


class PathDocs extends BaseComponent {


    constructor(props) {
        super(props);
        const state = {
            items: [],
            showMods: false
        }
        this.state = {
            ...this.state,
            ...state
        }

        this.modalBack = () => {
            this.setState({showMods: false})
            this.props.parent.setState({disableModalBack: false})
        };
    }

    receiveMessage = (event) => {
        if (event.data == 'modalBack') {
            if (this.state.showMods) {
                this.modalBack()
            }
        }
    }

    componentDidMount() {
        this.getItems()
    }

    sortCurrentSeries = (series, setState = true) => {

        let old = series


        old.sort(function (a, b) {

            if (a.ost_qnt * 1 == b.ost_qnt * 1) return 0;

            return a.ost_qnt * 1 > b.ost_qnt * 1 ? 1 : -1;

        });

        if (setState) {
            old.map((el, i) => {
                old[i].ost_qnt = (el.ost_qnt * this.props.product.unit.K / this.props.current_unit.K)
            })
            this.setState({items: old})
        }
        return old
    }


    getItems = () => {
        const body = new FormData()
        body.append('product_id', this.props.product.id)
        body.append('sclad_id', this.props.sclad.sclad_id)
        let sAjaxSource = '/?app=partnersproducts&act=getProductPathjsonDocs';

        this.setState({
            items: []
        });
        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true
            }
        ).then((response) => {
            this.setState({items: response.data.results})

        })

    }


    addOrEditToCart_ = async () => {
        let hasErrors = false;
        let i;
        let len = this.state.items.length

        const krat_unit = this.props.product.krat_unit
        const mods = new checkMods({...this.props, keyBase}, {current_unit: this.props.current_unit, ...this.state})


        for (i = 0; i < len; i++) {
            let item = this.state.items[i];
            if (item.order_qnt != undefined && item.order_qnt * 1 > 0) {

                hasErrors = !item.seria;
                console.log(hasErrors)
                if (true || !hasErrors) {


                    hasErrors = await mods.checkMods(item, i)

                }

                if (hasErrors === false) {

                    let {current_unit} = this.props


                    if (krat_unit !== null) {
                        current_unit = krat_unit
                    }

                    item.sclad_id = this.props.sclad.sclad_id;
                    item.series_id = item.seria.ost_id;
                    item.series_code = item.seria.code;
                    item.meta_id = this.props.product.id;


                    item.unit_id = current_unit.external_id
                    item.unit_name = current_unit.title
                    item.unit = current_unit

                    item.quantity = (item.order_qnt * 1).toFixed(3).toString().replace('.000', '')
                    if (this.props.sclad.unit_price) {
                        item.price = ((this.props.sclad.is_manual ? this.props.sclad.manual_price : this.props.sclad.base_price) * this.props.current_unit.K / this.props.sclad.unit_price.K).toFixed(2).toString().replace('.00', '')
                    } else {
                        item.price = 0.0;
                    }
                    if (item.cart_id != undefined) {
                        item.id = item.cart_id
                    }
                    CartApi.addOrEdit(item)

                } else {
                    //  if (hasErrors === true) break
                    this.props.parent.setState({disableModalBack: true})
                    this.setState({current_item: item, current_index: i, ...hasErrors})
                    this.setState({showMods: true})
                    break;
                }
            }
        }
        /*        if (hasErrors === false) {
                    CartApi.saveItems()
                    this.props.hideScissors();
                }*/
    }
    addAllQnt = (index) => {
        let old = this.state.items;
        let item_ = old[index]
        old[index].quantity = (item_.ost_qnt * this.props.product.unit.K / this.props.current_unit.K).toFixed(4).toString().replace('.0000', '')
        old[index].order_unit = this.props.current_unit
        console.log(item_)
        this.setState({items: old});
    }
    changeOrder = (e, index) => {

        let value = e.target.value.replace(',', '.')
        const match = value.match('([0-9]+[\.\,]?([0-9]{1,3})?)')
//        console.log(match)
        if (value !== '') {
            if (!match || value * 1 == 0) return
        }
        this.noRender = true
        let old = this.state.items;
        old[index].quantity = match ? match[0] : '';
        old[index].order_unit = this.props.current_unit;
        this.setState({items: old});
    }

    addOrEditToCart = async () => {
        let hasErrors = false;
        let i;
        let len = this.state.items.length

        const krat_unit = this.props.product.krat_unit
        const mods = new checkMods({...this.props, keyBase}, {current_unit: this.props.current_unit, ...this.state})
        for (i = 0; i < len; i++) {
            let item = this.state.items[i];
            if (item.quantity != undefined && item.quantity * 1 > 0) {


                hasErrors = await mods.checkMods(item, i)

                if (hasErrors === false) {
                    let {current_unit} = this.props


                    if (krat_unit !== null) {
                        current_unit = krat_unit
                    }
                    item.id = undefined;
                    item.sclad_id = this.props.sclad.sclad_id;
                    item.doc_guid = item.guid;
                    item.doc_name = item.nomer_doc + ' от ' + item.date_doc;
                    item.doc_type = item.type ? item.type : '';
                    item.meta_id = this.props.product.id;

                    item.unit_id = current_unit.external_id
                    item.unit_name = current_unit.title
                    item.unit = current_unit

                    item.quantity = (item.quantity * 1).toFixed(3).toString().replace('.000', '')
                    if (this.props.sclad.unit_price) {
                        item.price = ((this.props.sclad.is_manual ? this.props.sclad.manual_price : this.props.sclad.base_price) * this.props.current_unit.K / this.props.sclad.unit_price.K).toFixed(2).toString().replace('.00', '')
                    } else {
                        item.price = 0.0;
                    }

                    CartApi.addOrEdit(item)
                } else {
                    if (hasErrors === true) break
                    this.props.parent.setState({disableModalBack: true})
                    this.setState({current_item: item, current_index: i, ...hasErrors})
                    this.setState({showMods: true})
                    break;
                }
            }
        }
        if (hasErrors === false) {
            CartApi.saveItems()
            this.props.hideSeries();
        }
    }
    setCurrentQnt = (qnt, index, unit, dont_mods = false) => {
        let old = this.state.items;
        let item_ = old[index]
        old[index].quantity = (qnt * this.state.current_item.order_unit.K / unit.K).toFixed(3).toString().replace('.0000', '').replace('.000', '')
        old[index].order_unit = unit
        old[index].from_mods = true
        if (dont_mods) {
            old[index].dont_mods = true
        }

        this.setState({items: old});
        this.props.setCurrentUnit(unit.external_id)
        this.modalBack()
    }

    render() {
        setTimeout(() => this.noRender = false, 500)


        if (this.state.showMods) {
            return (
                <Group style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "start",
                    padding: "12px"

                }}>
                    <div>
                        <p>{'Укажите варианты заказа в ' + this.props.current_unit.title + ', кратный единице измерения "' + (this.state.current_pack_unit || this.props.product.pack_unit).title + '"'}</p>
                        {this.state.current_item == undefined ? '' : this.props.product.units.map((itemU, indexU) => {
                                if (this.props.product.isUnique == '1' || this.props.product.krat_unit) {
                                    if (itemU.external_id != this.props.product.pack_unit.external_id) return
                                }
                                return <ButtonGroup mode="horizontal" stretched style={{marginBottom: "12px"}}>

                                    <Button stretched
                                            onClick={() => this.setCurrentQnt(this.state.current_min, this.state.current_index, itemU, this.props.product.isUnique == '1')}>
                                        {(this.state.current_min * this.state.current_item.order_unit.K / itemU.K).toFixed(3).toString().replace('.0000', '').replace('.000', '') + itemU.title}
                                    </Button>
                                    <Button stretched
                                            onClick={() => this.setCurrentQnt(this.state.current_max, this.state.current_index, itemU, this.props.product.isUnique == '1')}>
                                        {(this.state.current_max * this.state.current_item.order_unit.K / itemU.K).toFixed(3).toString().replace('.0000', '').replace('.000', '') + itemU.title}
                                    </Button>
                                    {!this.props.product.krat_unit && this.props.product.isUnique != '1' &&
                                        <Button stretched disabled={this.props.ffc_mode === true}
                                                onClick={() => this.setCurrentQnt(this.state.current_item.quantity, this.state.current_index, itemU, true)}>
                                            {(this.state.current_item.quantity * this.state.current_item.order_unit.K / itemU.K).toFixed(3).toString().replace('.0000', '').replace('.000', '') + itemU.title}
                                        </Button>}


                                </ButtonGroup>
                            }
                        )}
                    </div>
                </Group>
            )
        } else {
            const productOrderBlock = getProductOrderBlock(this.props.product, this.props.current_user)
            const scladBlockReason = getScladBlockReason(this.props.sclad)

            const mobile = constants.AdaptivityContext.isMobile
            const colDoc = mobile ? {flex: '0.9 1 0', minWidth: 0} : undefined
            const colDate = mobile ? {flex: '1.35 1 0', minWidth: 0} : undefined
            const colQnt = mobile ? {flex: '0.95 1 0', minWidth: 0} : undefined
            const headPad = mobile ? {padding: '6px 2px'} : undefined
            return (
                <Div>
                    <SplitLayout>
                        <SplitCol>
                            <FormItem style={{textAlign: "right"}}>
                                <Button size="l" before={<Icon12CheckCircle/>} stretched onClick={async () => {
                                    await this.addOrEditToCart()
                                }}>Подтвердить</Button>
                            </FormItem>

                        </SplitCol>
                    </SplitLayout>
                    <SplitLayout style={{marginBottom: "50px"}}>
                        <SplitCol>
                            <SplitLayout style={{
                                alignItems: 'center',
                                borderBottom: '#dadada 1px solid',
                                fontSize: mobile ? '12px' : '14px',
                                fontWeight: 'bold'
                            }}>
                                <SplitCol style={colDoc}>
                                    <FormItem noPadding={mobile} style={headPad}>
                                        Документ
                                    </FormItem>
                                </SplitCol>
                                <SplitCol style={colDate}>
                                    <FormItem noPadding={mobile} style={headPad}>
                                        <span className="red" style={{
                                            color: "red",
                                            display: "block",
                                            textAlign: "center",
                                            fontSize: mobile ? "11px" : undefined,
                                            lineHeight: 1.15,
                                            fontWeight: 600,
                                            wordBreak: "normal",
                                            overflowWrap: "normal"
                                        }}>{mobile ? <>Планируемая<br/>дата поступления<br/>на склад</> : 'Планируемая дата поступления на склад'}</span>
                                    </FormItem>
                                </SplitCol>
                                <SplitCol style={colQnt}>
                                    <FormItem noPadding={mobile} style={headPad}>
                                        Количество
                                    </FormItem>
                                </SplitCol>
                            </SplitLayout>
                            {this.state.items ? this.state.items.map((doc_item, index) => (
                                <SplitLayout
                                    style={{alignItems: 'center', borderBottom: '#dadada 1px solid', fontSize: '12px'}}>
                                    <SplitCol style={colDoc}>
                                        <FormItem>
                                            <div>{doc_item.nomer_doc}</div>
                                            {doc_item.date_doc}
                                        </FormItem>
                                    </SplitCol>
                                    <SplitCol style={colDate}>
                                        <FormItem>
                                            <span className="red" style={{color: "red", display: "block", textAlign: mobile ? "center" : undefined}}>{doc_item.date_in}</span>
                                        </FormItem>
                                    </SplitCol>
                                    <SplitCol style={colQnt}>
                                        <FormItem>
                                            {(doc_item.ost_qnt * this.props.product.unit.K / this.props.current_unit.K).toFixed(3).toString().replace('.000', '')}
                                            <b>{this.props.current_unit.title}</b>
                                            <Button mode="primary" size="s" mode="secondary"
                                                    style={{marginBottom: '2px'}}
                                                    disabled={scladBlockReason.blocked || productOrderBlock.blocked}
                                                    stretched onClick={() => this.addAllQnt(index)}>
                                                <Icon16ArrowshapeRightOutline/>
                                            </Button>
                                            <Input className={constants.AdaptivityContext.isMobile ? "order-input" : ""}
                                                   placeholder="Заказать"
                                                   onChange={(e) => this.changeOrder(e, index)}
                                                   disabled={scladBlockReason.blocked || productOrderBlock.blocked}
                                                   value={this.noRender ? doc_item.quantity : (doc_item.order_unit == undefined ? '' : (doc_item.quantity * doc_item.order_unit.K / this.props.current_unit.K).toFixed(3).toString().replace('.000', ''))}
                                                   type="text"
                                            />
                                        </FormItem>
                                    </SplitCol>
                                </SplitLayout>)) : ''}
                        </SplitCol>

                    </SplitLayout>
                </Div>
            )
        }
    }

    formatQnt = (number) => {
        let result = number;

        result = (result * 1).toFixed(3).replace('.000', '')
        if (number.toString().indexOf('.') != -1) {
            while (result.endsWith('0')) {
                result = result.substring(0, result.length - 1)
            }
        }
        return result;
    }
}

export default PathDocs